/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-04-11 17:56:10
 * @Description:
 */
export default {
  Problem_feedback: 'กรุณากรอกคำถามและข้อเสนอแนะของคุณ',
  contact_information: 'กรุณาระบุข้อมูลการติดต่อ',
  contact_information_the: 'กรุณาระบุข้อมูลการติดต่อของคุณ',
  import: 'เข้า',
  Please_enter: 'กรุณาเข้าสู่ระบบ',
  Old_password: 'รหัสผ่านเก่า',
  New_password: 'รหัสผ่านใหม่',
  Required: 'ที่จำเป็น',
  Enteranewpassword: 'กรอกรหัสผ่านใหม่',
  Confirm_new_password: 'ยืนยันรหัสผ่านใหม่',
  mobile: 'เบอร์โทรศัพท์',
  QQ: 'หมายเลข QQ',
  postbox: 'เมล',
  contact_you: 'สะดวกในการติดต่อคุณ',
  question: 'กรุณากรอกคำถามของคุณ',
  Characters_up: '6-16 ตัวอักษร',
  address: 'กรุณากรอกที่อยู่ให้ละเอียด',
  renewal_contact: 'กรุณาระบุข้อมูลติดต่อต่ออายุ',
  ple_contact_name: 'กรุณากรอกชื่อผู้ติดต่อ',
  Please_enter_withdrawal: 'กรุณากรอกรายละเอียดการถอนเงิน',
  Number_of_cards: 'จำนวน',
  Pleasechooseanagent: 'กรุณาเลือกตัวแทน',
  Pleaseenterthequantity: 'กรุณากรอกจำนวน',
  Pleaseentertheuserprefixnickname: 'กรุณากรอกชื่อเล่นคำนำหน้าผู้ใช้ของคุณ (2-26 หลัก)',
  PleaseEnterImei: 'กรุณากรอกหมายเลข IMEI 15 หลัก',
  Remarkswithin: 'หมายเหตุ: ภายใน 100 คำ',
  Pleaseselectaunit: 'กรุณาเลือกหน่วยของคุณ',
  Pleaseselectagrouptojoin: 'กรุณาเลือกกลุ่มที่จะเข้าร่วม',
  Pleaseentertheunitname: 'กรุณากรอกชื่อองค์กรของคุณ',
  companynamerequired: '(ต้องมี: 4-20 ตัวอักษร, ตัวอักษร, ตัวเลข)',
  Pleaseenterloginaccount: 'กรุณากรอกบัญชีเข้าสู่ระบบของคุณ',
  loginaccountrequired: '(จำเป็นต้องมี: ตัวอักษรและตัวเลข 6-20 ตัว)',
  Pleaseenteryourpassword: 'กรุณากรอกรหัสผ่านเข้าระบบ',
  loginpasswordrequired: '(จำเป็นต้องมี: ตัวอักษรและตัวเลข 6-16 ตัว)',
  Pleaseenteracontactname: 'กรุณากรอกชื่อผู้ติดต่อ',
  contactnamerequired: '(จำเป็นต้องมี: 2-20 ตัวอักษร, ตัวอักษร, ตัวเลข)',
  Pleaseenteraprefixname: 'กรุณาใส่คำนำหน้าชื่อ',
  prefixnamerequired: '(จำเป็นต้องมี: 2-12 ตัวอักษร, ตัวอักษร, ตัวเลข)',
  Contactnamerequired20: 'ชื่อผู้ติดต่อ (จำเป็น: 2-20 ตัวอักษร)',
  mobilephonenumber: 'เบอร์โทรศัพท์มือถือ (ไม่บังคับ)',
  Enteremailaddress: 'กรอกที่อยู่อีเมล์ของคุณ (ไม่บังคับ)',
  Enterdetailedaddress: 'กรอกรายละเอียดที่อยู่ (ไม่บังคับ)',
  Pleaseenteragroupname: 'กรุณาระบุชื่อกลุ่ม (จำเป็นต้องมี 2-15 ตัวอักษร)',
  Groupnamerequired: 'ชื่อกลุ่ม (จำเป็นต้องมี: 2-15 ตัวอักษร)',
  Pleasetypeyourphonenumber: 'กรุณากรอกเบอร์ติดต่อของคุณ',
  Pleaseinputtheemailaddress: 'กรุณากรอกที่อยู่อีเมล์ของคุณ',
  Pleaseenterthemailingaddress: 'กรุณากรอกที่อยู่จัดส่ง',
  RequiredPleaseenterusernickname: '(จำเป็น) กรุณากรอกชื่อเล่นผู้ใช้ของคุณ',
  Pleasemobilephonenumber: '(ไม่บังคับ) กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ',
  PleaseentertheoriginalIMEInumber: 'กรุณากรอกหมายเลข IMEI 15 หลักเดิม',
  PleaseenterthenewIMEInumber: 'กรุณากรอกหมายเลข IMEI ใหม่ 15 หลัก',
  Pleaseenteraverificationcode: 'กรุณากรอกรหัสยืนยัน 4 หลัก',
  Pleaseenterthemobilephonenumbertobebound: 'กรุณากรอกเบอร์มือถือที่ต้องการผูก',
  PleaseenteragroupnameTow: 'กรุณากรอกชื่อกลุ่ม',
  Pleaseenterusername: 'กรุณากรอกชื่อผู้ใช้ของคุณ',
  Fencenamerequired: 'ชื่อรั้ว (จำเป็นต้องมี: 1-15 ตัวอักษร)',
  Pleaseenterthefencename: 'กรุณากรอกชื่อรั้ว',
  Pleaseselectatime: 'กรุณาเลือกเวลา',

  please_rest_password: 'เพื่อความปลอดภัยของบัญชีของคุณ ขอแนะนำให้รีเซ็ตรหัสผ่านการเข้าสู่ระบบก่อน',
  TheLastGroupUnderTheUnitCannotBeDeleted: 'กลุ่มสุดท้ายภายใต้หน่วยไม่สามารถลบได้',
}
